import React from 'react'
import Button from './Button'

function Info({info}){
    return(
        <div className='info' >
            {Object.keys(info).map((val) => (
                <p className='information' >
                    <span>{val.split('_').map((infoval) => (
                        <span>{infoval.toUpperCase()} </span>
                    ))} : </span>
                    <span>{info[val]}</span>
                </p>
            ))}
        </div>
    )
}



function Weather({weather,setScreen}) {

    return (
        weather?
    <div className={`weather`} >
        <div className='refresh' onClick={() => {setScreen(2)}} >
            <Button title={'Previous'} />
        </div>
        <h2>{weather?.name} 
        <img src={`https://openweathermap.org/img/w/${weather.weather[0].icon}.png`} />
        </h2> 
         {/*<p>
            {
                Object?.keys(weather?.coord).map((val) => (
                    <span >{val}: {weather?.coord[val]} </span>
                ))
            }
        </p> */}

        
        <div className='info-panel' >
            <Info info={weather?.coord} />
            <Info info={weather?.main} />
            <Info info={weather?.wind} />
            {/* <Info info={weather?.sys} /> */}

        </div>
    </div>:<></>
  )
}

export default Weather